import { render, staticRenderFns } from "./SettingsCustomFieldEditModal.vue?vue&type=template&id=5122ea92&"
import script from "./SettingsCustomFieldEditModal.vue?vue&type=script&lang=js&"
export * from "./SettingsCustomFieldEditModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCustomFieldEditModal.vue?vue&type=style&index=0&id=5122ea92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports